import { z } from 'zod';

export const CustomerRecord = z.object({
  id: z.string(),
  name: z.string().min(1).max(256),
  addressLine1: z.string().nullable().optional(),
  addressLine2: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  region: z.string().nullable().optional(),
  postcode: z.string().nullable().optional(),
  billingContactName: z.string().nullable().optional(),
  billingEmail: z.string().email().nullable().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable().optional(),
});
export type CustomerRecord = z.infer<typeof CustomerRecord>;

export const CustomerCreateRequest = z.object({
  name: z.string().min(1).max(256),
  addressLine1: z.string().nullable().optional(),
  addressLine2: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  region: z.string().nullable().optional(),
  postcode: z.string().nullable().optional(),
  billingContactName: z.string().nullable().optional(),
  billingEmail: z.string().email().nullable().optional(),
});
export type CustomerCreateRequest = z.infer<typeof CustomerCreateRequest>;

export const CustomerUpdateRequest = CustomerCreateRequest.partial();
export type CustomerUpdateRequest = z.infer<typeof CustomerUpdateRequest>;

export const CustomerListResponse = z.object({
  items: z.array(CustomerRecord),
  total: z.number().int().nonnegative(),
});
export type CustomerListResponse = z.infer<typeof CustomerListResponse>;
